/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bzHsBkgGqqFqgQ8Ug5BFVy
import { createUseGlobalVariants } from "@plasmicapp/react-web";
import { useScreenVariants as useScreenVariants_9JXhFit0FNVj } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: 9jXhFit0fNVj/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariants_9JXhFit0FNVj
});
